import React from "react";

function IncautacionTable(props) {
  return (
    <table className="table-layers-results table-spaces">
      <thead>
        <tr>
          <th className="name no-select">Ocupante</th>
          <th style={{width: '260px'}} className="name no-select">Localidad</th>
          <th className="name no-select">Barrio</th>
          <th className="name no-select">Fecha</th>
          <th className="name no-select">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {props.list.map((item) => (
          <tr key={"row-table-hg-ash-" + item.id}>
            <td className="user"> {item.occupant ?? ''} </td>
            <td style={{width: '260px'}} className="user no-select">{item.refComuna ? item.refComuna.name : ''}</td>
            <td className="user no-select">{item.refBarrio ? item.refBarrio.name : ''}</td>
            <td className="user">{item.now ? item.now.split('T')[0] : ''}</td>
            <td className="user no-select pointer flex-center">
              <div className="flex-center">
                <div onClick={() => props.onGetPdf(item.id)} className={'kml-input-form-bottons red-background-color on-mouse-hover'} title={`Descargar PDF ${item.number}`}>
                  <i className="fas fa-file-pdf"></i>
                </div>
              </div>
              <div className="flex-center">
                <div onClick={() => props.onOpen(item.id)} className={'kml-input-form-bottons green-background-color on-mouse-hover'} title={`Ver información ${item.number}`}>
                  <i className="fas fa-eye"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default IncautacionTable;
